import { styled } from '@mui/material/styles';

import {
    containerSmallWidth,
    Theme,
    rem,
    remToGapMultiplier,
} from '../../theme';
import { Heading } from '../Heading';
import { Paragraph } from '../Paragraph';

export const StyledContainer = styled('div')`
    ${({ theme }: { theme: Theme }) => `
        display: flex;
        flex-direction: column;

        ${theme.breakpoints.up('desktop')} {
            align-items: center;
            justify-content: center;
            margin: ${theme.tggSpacing([rem(8), rem(8), 0, rem(8)], [20, 20, 0, 20])};
        }
    `}
`;

export const StyledTextContainer = styled('div')`
    ${({ theme }: { theme: Theme }) => `
        margin: ${theme.tggSpacing([0, rem(3)], [0, 7.5])};

        ${theme.breakpoints.up('desktop')} {
            margin: ${theme.tggSpacing(0, 0)};
            text-align: center;
        }
    `}
`;

export const StyledTitle = styled(Heading)`
    ${({ theme }: { theme: Theme }) => `
        margin: ${theme.tggSpacing([rem(3), 0, rem(1)], [7.5, 0, 2.5])};

        ${theme.breakpoints.up('desktop')} {
            margin: ${theme.tggSpacing([rem(4), 0, rem(3)], [10, 0, 7.5])};
        }
    `}
`;

export const StyledDescription = styled(Paragraph)`
    && {
        ${({ theme }: { theme: Theme }) => `
            margin-bottom: ${theme.tggSpacing(rem(1), 2.5)};

            ${theme.breakpoints.up('desktop')} {
                max-width: ${theme.tggSpacing(rem(containerSmallWidth), containerSmallWidth * remToGapMultiplier)};
                margin-bottom: ${theme.tggSpacing(rem(3), 7.5)};
            }
        `}
    }
`;
